import { parseStringAsSlug } from '@tools/parsers';
import { useId as useVueId } from 'vue';

export function useId(prefix: string): string;
export function useId<const T extends string>(prefix: string, fields: T[]): Record<T, string>;
export function useId(prefix: string, fields?: string[]) {
  const id = useVueId();

  const parseId = (field?: string) =>
    [parseStringAsSlug(prefix), id, field ? parseStringAsSlug(field) : field]
      .filter(Boolean)
      .join('-');

  return fields ? Object.fromEntries(fields.map((field) => [field, parseId(field)])) : parseId();
}
